import PropTypes from 'prop-types';
import SimpleFooter from '@outdoor-voices/ui/dist/components/Footer';
import EmailOnly from './EmailOnly';
import WithEmail from './WithEmail';
import { footerLinks } from './Links';
import { jsx as _jsx } from "react/jsx-runtime";

var Footer = function Footer(_ref) {
  var emailOnly = _ref.emailOnly,
      fixBehind = _ref.fixBehind,
      hasBackgroundColor = _ref.hasBackgroundColor,
      nameOnly = _ref.nameOnly,
      listId = _ref.listId,
      noFooter = _ref.noFooter,
      source = _ref.source,
      withEmail = _ref.withEmail;

  if (noFooter) {
    return false;
  }

  if (emailOnly) {
    return /*#__PURE__*/_jsx(EmailOnly, {
      source: source
    });
  }

  if (withEmail) {
    return /*#__PURE__*/_jsx(WithEmail, {
      fixBehind: fixBehind,
      hasBackgroundColor: hasBackgroundColor,
      links: footerLinks,
      listId: listId,
      nameOnly: nameOnly,
      source: source
    });
  }

  return /*#__PURE__*/_jsx(SimpleFooter, {
    shopURL: "/"
  });
};

Footer.defaultProps = {
  emailOnly: false,
  fixBehind: false,
  hasBackgroundColor: false,
  listId: false,
  nameOnly: false,
  noFooter: false,
  source: '',
  withEmail: false
};
Footer.propTypes = {
  emailOnly: PropTypes.bool,
  fixBehind: PropTypes.bool,
  hasBackgroundColor: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  nameOnly: PropTypes.bool,
  listId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  noFooter: PropTypes.bool,
  source: PropTypes.string,
  withEmail: PropTypes.bool
};
export default Footer;